import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { useSupportUnreadCount } from '../../api/support/useSupport';
import SupportChatPanel from './SupportChatPanel';
import { useHelpLaunchersHidden } from '../../helpers/helpLaunchers';

/**
 * Mêmes pages que l'ancien lanceur Intercom : le bouton gênerait les actions en bas à droite.
 * La file du support super admin y ajoute sa zone de réponse collée en bas de l'écran.
 */
const HIDDEN_PREFIXES = ['/messaging', '/cardex', '/super-admin/support'];

export default function SupportChatBubble() {
    const { t } = useTranslation('support');
    const { pathname, search } = useLocation();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const { data: unread } = useSupportUnreadCount(true);
    // Un écran plein (assistant IA des e-mails) demande à ne pas être recouvert en bas à droite.
    const isHiddenByScreen = useHelpLaunchersHidden();

    // Lien de l'e-mail de réponse de l'équipe : ?support=open
    useEffect(() => {
        if (new URLSearchParams(search).get('support') === 'open') setIsOpen(true);
    }, [search]);

    // Retire ?support=open pour que le prochain clic de « Poser la question » change l'URL et rouvre la bulle.
    const handleClose = useCallback(() => {
        setIsOpen(false);
        const params = new URLSearchParams(search);
        if (params.has('support')) {
            params.delete('support');
            const rest = params.toString();
            navigate({ pathname, search: rest ? `?${rest}` : '' }, { replace: true });
        }
    }, [navigate, pathname, search]);

    const isHidden = isHiddenByScreen || HIDDEN_PREFIXES.some((prefix) => pathname.startsWith(prefix));
    if (isHidden) return null;

    const count = unread?.count ?? 0;

    return (
        <>
            {isOpen && <SupportChatPanel onClose={handleClose} />}
            {/* Lanceur rond fixe : Button ne sait pas rendre un bouton flottant circulaire. */}
            <button type="button" onClick={() => (isOpen ? handleClose() : setIsOpen(true))} aria-label={isOpen ? t('close') : t('open')} aria-expanded={isOpen}
                className="fixed bottom-4 right-4 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-primary-color text-white shadow-lg hover:bg-primary-color-light">
                <ChatBubbleLeftRightIcon className="h-7 w-7" />
                {count > 0 && (
                    <span className="absolute -right-1 -top-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-white px-1 text-xs font-medium text-primary-color ring-1 ring-primary-color">
                        {count}
                    </span>
                )}
            </button>
        </>
    );
}
